import BreadcrumbsContainer from '../../containers/common/breadcurmbs/BreadcrumbsContainer';
import BudgetContainer from '../../containers/establish/BudgetContainer';

const BudgetPage = () => {
  return (
    <>
      <BreadcrumbsContainer title="예산관리/연간 예산 수립" icon="budget" />
      <BudgetContainer />
    </>
  );
};

export default BudgetPage;
